// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let FeedbackStepCompletion
export default FeedbackStepCompletion = class FeedbackStepCompletion extends (
  require("lib/static-shim").default(require("lib/utils/model").default)
) {
  // Note: this model is only used to view and give feedback on a student step
  url() {
    let url
    const { path_id, completion_id } = this.attributes
    // NOTE: appending a cache_bust param to prevent the preflight request being send with a
    // "if-none-match" request header which our backend doesn't support.
    return (url = this.urlRoot(
      `/api/private/path/${path_id}/completion/${completion_id}/?cache_bust=${new Date().getTime()}`
    ))
  }
}
